import { render, staticRenderFns } from "./page-shop.vue?vue&type=template&id=0d006035&scoped=true"
import script from "./page-shop.vue?vue&type=script&lang=js"
export * from "./page-shop.vue?vue&type=script&lang=js"
import style0 from "./page-shop.vue?vue&type=style&index=0&id=0d006035&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d006035",
  null
  
)

export default component.exports